import React, { Component } from 'react'
import styled from 'styled-components'
import {
  Popconfirm,
  Button,
  Form,
  Radio,
  DatePicker,
  AutoComplete,
  Input,
  Icon,
  Tooltip
} from 'antd'
import ReactTable from 'react-table'
import moment from 'moment'
import _ from 'lodash'
import { convertToOption, convertNamesToOption, filterCaseInsensitive } from '../util'

const FormItem = Form.Item
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const { TextArea } = Input

const AddItemsContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`

class FollowUps extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachmentDetailsVisible: false
    }
  }

  onFollowUpInputChange = e => {
    this.setState({
      followUpContent: e.target.value
    })
  }

  handleAddEditFollowUp = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (this.props.currentFollowUp) {
        values.updated_by_id = this.props.userId
        values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')
        values.due_date = moment(values.due_date).format('YYYY/MM/DD HH:mm:ss')
        if (_.isNaN(parseInt(values.assigned_to_id))) {
          delete values.assigned_to_id
        }

        this.props.updateFollowUp(values)
      } else {
        values.created_by_id = this.props.userId
        values.updated_by_id = this.props.userId
        values.created_date = moment().format('YYYY/MM/DD HH:mm:ss')
        values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')
        values.due_date = moment(values.due_date).format('YYYY/MM/DD HH:mm:ss')

        this.props.createFollowUp(values)
      }

      form.resetFields()
    })
  }

  handleClearFormBeforeOpenClose = () => {
    const form = this.props.form

    this.props.handleResetFollowUpForm()

    if (!this.props.followUpAddEditContainer) {
      this.props.handleToggleFollowUpEditArea()
    }

    form.resetFields()
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { followUpAddEditContainer, followUps, currentFollowUp } = this.props
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <h4>FollowUps</h4>
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <Button
                  icon="plus"
                  onClick={() => this.handleClearFormBeforeOpenClose()}
                  className="ml-2"
                >
                  {' '}
                  Add FollowUp
                </Button>
              </div>
            </div>
            {followUpAddEditContainer && (
              <AddItemsContainer>
                <Form>
                  <div className="row">
                    <div className="col-md-4">
                      <FormItem label="Type">
                        {getFieldDecorator('type', {
                          rules: [
                            {
                              required: true,
                              message: 'Type cannot be blank.'
                            }
                          ],
                          initialValue:
                            currentFollowUp && currentFollowUp.type ? currentFollowUp.type : null
                        })(
                          <RadioGroup>
                            <RadioButton value="General">General</RadioButton>
                            <RadioButton value="Callback">Callback</RadioButton>
                          </RadioGroup>
                        )}
                      </FormItem>
                    </div>
                    <div className="col-md-4">
                      <FormItem label="Status">
                        {getFieldDecorator('status', {
                          rules: [
                            {
                              required: true,
                              message: 'Status cannot be blank.'
                            }
                          ],
                          initialValue:
                            currentFollowUp && currentFollowUp.status
                              ? currentFollowUp.status
                              : null
                        })(
                          <RadioGroup onChange={this.onChange}>
                            <RadioButton value="Opened">Opened</RadioButton>
                            <RadioButton value="Closed">Closed</RadioButton>
                          </RadioGroup>
                        )}
                      </FormItem>
                    </div>
                    <div className="col-md-4">
                      <FormItem label="Due Date">
                        {getFieldDecorator('due_date', {
                          rules: [
                            {
                              required: true,
                              message: 'Due Date cannot be blank.'
                            }
                          ],
                          initialValue:
                            currentFollowUp && currentFollowUp.due_date
                              ? moment(currentFollowUp.due_date)
                              : null
                        })(<StyledDatePicker />)}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3">
                      <FormItem label="Assigned To Type">
                        {getFieldDecorator('assigned_to_type', {
                          initialValue: this.props.followUpAssignToType
                        })(
                          <RadioGroup onChange={this.props.changeAssignedToType}>
                            <RadioButton value="user">User</RadioButton>
                            <RadioButton value="role">Role</RadioButton>
                          </RadioGroup>
                        )}
                      </FormItem>
                    </div>
                    <div className="col-9">
                      {this.props.followUpAssignToType === 'user' && (
                        <FormItem label="Assign To User">
                          {getFieldDecorator('assigned_to_id', {
                            rules: [
                              {
                                required: this.props.followUpAssignToType === 'user' ? false : true,
                                message: 'You must assign this to someone'
                              }
                            ],
                            initialValue:
                              currentFollowUp && currentFollowUp.assigned_to_id
                                ? `${currentFollowUp.first_name} ${currentFollowUp.last_name}`
                                : null
                          })(
                            <AutoComplete
                              dataSource={convertNamesToOption(this.props.autocompleteUsers)}
                              filterOption={(inputValue, option) =>
                                option.props.children
                                  .toUpperCase()
                                  .indexOf(inputValue.toUpperCase()) !== -1
                              }
                            >
                              <Input
                                suffix={<Icon type="search" className="certain-category-icon" />}
                              />
                            </AutoComplete>
                          )}
                        </FormItem>
                      )}
                      {this.props.followUpAssignToType === 'role' && (
                        <FormItem label="Assign To Role">
                          {getFieldDecorator('assigned_to_role_id', {
                            rules: [
                              {
                                required: this.props.followUpAssignToType === 'role' ? false : true,
                                message: 'You must assign this to someone'
                              }
                            ],
                            initialValue:
                              currentFollowUp && currentFollowUp.assigned_to_role_id
                                ? currentFollowUp.assigned_to_role_id.toString()
                                : null
                          })(
                            <AutoComplete
                              dataSource={convertToOption(this.props.autocompleteRoles)}
                              filterOption={(inputValue, option) =>
                                option.props.children
                                  .toUpperCase()
                                  .indexOf(inputValue.toUpperCase()) !== -1
                              }
                            >
                              <Input
                                suffix={<Icon type="search" className="certain-category-icon" />}
                              />
                            </AutoComplete>
                          )}
                        </FormItem>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <FormItem label="Description">
                        {getFieldDecorator('description', {
                          initialValue:
                            currentFollowUp && currentFollowUp.description
                              ? currentFollowUp.description
                              : null
                        })(<TextArea placeholder="Type the description..." rows={4} />)}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <Popconfirm
                        title="Are you sure you want to delete this record?"
                        onConfirm={this.props.deleteFollowUp}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        {currentFollowUp && <Button type="danger" icon="delete" className="mr-2" />}
                      </Popconfirm>
                      <Button
                        className="mr-2"
                        onClick={() => this.props.handleToggleFollowUpEditArea()}
                      >
                        Close
                      </Button>
                      <Button onClick={() => this.handleAddEditFollowUp()}>
                        {currentFollowUp ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </div>
                </Form>
              </AddItemsContainer>
            )}
            <ReactTable
              data={followUps}
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.props.handleRowFollowUpClick(rowInfo.original)
              })}
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Type',
                      id: 'type',
                      accessor: 'type',
                      Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>
                    },
                    {
                      Header: 'Description',
                      id: 'description',
                      accessor: 'description',
                      Cell: d => (
                        <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                      )
                    },
                    {
                      Header: 'Assigned To',
                      id: 'assigned_to_name',
                      accessor: d =>
                        d.assigned_to_role_name
                          ? d.assigned_to_role_name
                          : `${d.assigned_to_first_name} ${d.assigned_to_last_name}`,
                      Cell: d => {
                        let r = ''
                        if (d.original.assigned_to_role_name) {
                          r = d.original.assigned_to_role_name
                        } else {
                          r = `${d.original.assigned_to_first_name} ${
                            d.original.assigned_to_last_name
                          }`
                        }

                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      maxWidth: 110
                    },
                    {
                      Header: 'Due Date',
                      id: 'due_date',
                      accessor: 'due_date',
                      Cell: row => <span>{moment.utc(row.value).format('M/D/YYYY')}</span>,
                      minWidth: 70
                    },
                    {
                      Header: 'Status',
                      accessor: 'status',
                      Cell: row => {
                        let color = null
                        if (row.value === 'OVERDUE') {
                          color = '#ff2e00'
                        } else {
                          if (row.value === 'Opened') {
                            color = '#ffbf00'
                          } else {
                            color = '#57d500'
                          }
                        }
                        return (
                          <span>
                            <span
                              style={{
                                color: color,
                                transition: 'all .3s ease'
                              }}
                            >
                              &#x25cf;
                            </span>
                            {row.value}
                          </span>
                        )
                      },
                      maxWidth: 100
                    }
                  ]
                }
              ]}
              defaultPageSize={5}
              className="-striped -highlight"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Form.create()(FollowUps)



// WEBPACK FOOTER //
// ./src/components/FollowUps.js